"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDistanceString = exports.toNumericUs = exports.toDateTimeZone = exports.convertDateToISO8601String = exports.convertDateTimeValueToUtc = exports.parseDate = exports.formatDate = exports.getFormattedDateStringRelative = exports.getFormattedDateStringTime24hr = exports.getFormattedDateStringShortTime = exports.getFormattedDateStringYearMonthDay = exports.getFormattedDateStringShortWithWeekday = exports.getFormattedDateStringShort = exports.getFormattedDateStringFull = exports.getFormattedDateStringShortDateTime = exports.getFormattedDateStringMonthDayYearWithTime = exports.getFormattedDateStringMonthDayYear = exports.getFormattedDateStringLongDate = exports.getFormattedDateStringLongDateTime = void 0;

var _parse = _interopRequireDefault(require("date-fns/parse"));

var _isValid = _interopRequireDefault(require("date-fns/isValid"));

var _formatDistanceStrict = _interopRequireDefault(require("date-fns/formatDistanceStrict"));

var _dateFnsTz = require("date-fns-tz");

/**
 * Set of strings used to format dates with date-fns
 */
var dateFormats = {
  full: "EEE, MMM d, yyyy, h:mm aaaa z",
  short: "MMM do, yyyy",
  shortWithWeekday: "EEE, MMM d, yyyy",
  yearMonthDay: "yyyy-MM-dd",
  monthDayYear: "MM/dd/yyyy",
  monthDayYearWithTime: "MM/dd/yyyy h:mm aaaa",
  shortTime: "h:mm",
  shortDateTime: "MMM d, yyyy h:mm aaaa",
  longDate: "MMMM do, yyyy",
  longDateTime: "MMMM do, yyyy h:mm aaaa",
  time24hr: "HH:mm"
};
/**
 * Used to get a formatted string from a given date
 * @param {Date|string|number} date
 * @param {string} dateFormat
 */

var getFormattedDateString = function getFormattedDateString(date, dateFormat, timeZone) {
  if (!dateFormat) {
    throw new Error("dateFormat must be provided in order to format the date object.");
  }

  var dateObject = new Date(date);

  if (!date || !(0, _isValid.default)(dateObject)) {
    return "";
  }

  return (0, _dateFnsTz.format)(dateObject, dateFormat, {
    timeZone: timeZone
  });
};
/**
 * Returns a string formatted as "January 1st, 2019"
 * @param {Date|string|number} date
 * @param {string} timeZone
 */


var getFormattedDateStringLongDateTime = function getFormattedDateStringLongDateTime(date, timeZone) {
  return getFormattedDateString(date, dateFormats.longDateTime, timeZone);
};
/**
 * Returns a string formatted as "January 1st, 2019 1:23 PM"
 * @param {Date|string|number} date
 * @param {string} timeZone
 */


exports.getFormattedDateStringLongDateTime = getFormattedDateStringLongDateTime;

var getFormattedDateStringLongDate = function getFormattedDateStringLongDate(date, timeZone) {
  return getFormattedDateString(date, dateFormats.longDate, timeZone);
};
/**
 * Returns a string formatted as "2019-10-01"
 * @param {Date|string|number} date
 * @param {string} timeZone
 */


exports.getFormattedDateStringLongDate = getFormattedDateStringLongDate;

var getFormattedDateStringMonthDayYear = function getFormattedDateStringMonthDayYear(date, timeZone) {
  return getFormattedDateString(date, dateFormats.monthDayYear, timeZone);
};
/**
 * Returns a string formatted as "2019-10-01 1:23 PM"
 * @param {Date|string|number} date
 * @param {string} timeZone
 */


exports.getFormattedDateStringMonthDayYear = getFormattedDateStringMonthDayYear;

var getFormattedDateStringMonthDayYearWithTime = function getFormattedDateStringMonthDayYearWithTime(date, timeZone) {
  return getFormattedDateString(date, dateFormats.monthDayYearWithTime, timeZone);
};
/**
 * Returns a string formatted as "Oct 1, 2019 2:59 PM"
 * @param {Date|string|number} date
 * @param {string} timeZone
 */


exports.getFormattedDateStringMonthDayYearWithTime = getFormattedDateStringMonthDayYearWithTime;

var getFormattedDateStringShortDateTime = function getFormattedDateStringShortDateTime(date, timeZone) {
  return getFormattedDateString(date, dateFormats.shortDateTime, timeZone);
};
/**
 * Returns a string formatted as "Tue, Oct 1, 2019 2:59 PM CDT"
 * @param {Date|string|number} date
 * @param {string} timeZone
 */


exports.getFormattedDateStringShortDateTime = getFormattedDateStringShortDateTime;

var getFormattedDateStringFull = function getFormattedDateStringFull(date, timeZone) {
  return getFormattedDateString(date, dateFormats.full, timeZone);
};
/**
 * Returns a string formatted as "Oct 1, 2019"
 * @param {Date|string|number} date
 * @param {string} timeZone
 */


exports.getFormattedDateStringFull = getFormattedDateStringFull;

var getFormattedDateStringShort = function getFormattedDateStringShort(date, timeZone) {
  return getFormattedDateString(date, dateFormats.short, timeZone);
};
/**
 * Returns a string formatted as "Tue, Oct 1, 2019"
 * @param {Date|string|number} date
 * @param {string} timeZone
 */


exports.getFormattedDateStringShort = getFormattedDateStringShort;

var getFormattedDateStringShortWithWeekday = function getFormattedDateStringShortWithWeekday(date, timeZone) {
  return getFormattedDateString(date, dateFormats.shortWithWeekday, timeZone);
};
/**
 * Returns a string formatted as "2019-10-01"
 * @param {Date|string|number} date
 * @param {string} timeZone
 */


exports.getFormattedDateStringShortWithWeekday = getFormattedDateStringShortWithWeekday;

var getFormattedDateStringYearMonthDay = function getFormattedDateStringYearMonthDay(date, timeZone) {
  return getFormattedDateString(date, dateFormats.yearMonthDay, timeZone);
};
/**
 * Returns a string formatted as "2:59", between 1-12.
 * @param {Date|string|number} date
 * @param {string} timeZone
 */


exports.getFormattedDateStringYearMonthDay = getFormattedDateStringYearMonthDay;

var getFormattedDateStringShortTime = function getFormattedDateStringShortTime(date, timeZone) {
  return getFormattedDateString(date, dateFormats.shortTime, timeZone);
};
/**
 * Returns a string formatted as "18:59".
 * @param {Date|string|number} date
 * @param {string} timeZone
 */


exports.getFormattedDateStringShortTime = getFormattedDateStringShortTime;

var getFormattedDateStringTime24hr = function getFormattedDateStringTime24hr(date, timeZone) {
  return getFormattedDateString(date, dateFormats.time24hr, timeZone);
};
/**
 * Gets text such as "4 days ago" relative to two dates. The second date defaults to today if none is provided.
 * The order in which these are supplied is important to whether you get ending text such as "ago", or "from now".
 * @param {Date|string|number} start
 * @param {Date|string|number} end
 */


exports.getFormattedDateStringTime24hr = getFormattedDateStringTime24hr;

var getFormattedDateStringRelative = function getFormattedDateStringRelative(start) {
  var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  var startDate = new Date(start);
  var endDate = new Date(end);

  if (!startDate || !(0, _isValid.default)(startDate) || !(0, _isValid.default)(endDate)) {
    return "";
  }

  return (0, _formatDistanceStrict.default)(startDate, endDate, {
    addSuffix: true
  });
};
/**
 * Returns a string representation of the format string provided.
 * @param {Date|string|number} date
 * @param {string} format
 */


exports.getFormattedDateStringRelative = getFormattedDateStringRelative;

var formatDate = function formatDate(date, dateFormat) {
  var dateObject = new Date(date);

  if (!(0, _isValid.default)(dateObject)) {
    return "";
  }

  return (0, _dateFnsTz.format)(dateObject, dateFormat);
};
/**
 * Returns a Date object given the date string, and the format of the date string.
 * @param {string} str
 * @param {string} format
 */


exports.formatDate = formatDate;

var parseDate = function parseDate(str, format) {
  var parsed = (0, _parse.default)(str, format, new Date());

  if ((0, _isValid.default)(parsed)) {
    return parsed;
  }

  return undefined;
};
/**
 * Converts the given Date or string into an ISO string.
 * @param {Date|string|number} value
 * @param {string} format
 */


exports.parseDate = parseDate;

var convertDateTimeValueToUtc = function convertDateTimeValueToUtc(value) {
  var date = new Date(value);

  if (!(0, _isValid.default)(date)) {
    return "";
  } // Date().toISOString() returns "YYYY-MM-DDTHH:mm:ss.xxxxZ"
  // Headless implementation only accepts "YYYY-MM-DDTHH:mm:ssZ"
  // Get the user timezone from the Intl APIs


  return (0, _dateFnsTz.zonedTimeToUtc)(date, Intl.DateTimeFormat().resolvedOptions().timeZone).toISOString().replace(/.\d{3}Z/, "Z");
};
/* The ISO dates in JS follow a derived version of the ISO8601 spec. Noda Time uses a more direct version  */
// https://stackoverflow.com/a/23829390/299408


exports.convertDateTimeValueToUtc = convertDateTimeValueToUtc;

var convertDateToISO8601String = function convertDateToISO8601String(date) {
  function pad(n) {
    return n < 10 ? "0" + n : n;
  }

  if (!(date instanceof Date)) {
    date = new Date(date);
  }

  return date.getUTCFullYear() + "-" + pad(date.getUTCMonth() + 1) + "-" + pad(date.getUTCDate()) + "T" + pad(date.getUTCHours()) + ":" + pad(date.getUTCMinutes()) + ":" + pad(date.getUTCSeconds()) + "Z";
};

exports.convertDateToISO8601String = convertDateToISO8601String;

var toDateTimeZone = function toDateTimeZone(date, timeZone) {
  var dateOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  // Convert the given date to an ISO string
  var dateISOString = new Date(date).toISOString(); // The ISO string will then be converted to a Date object in the given timezone
  // And from that, we will then give it to the formatter to get the desired string.

  if (dateOnly) {
    return getFormattedDateStringMonthDayYear((0, _dateFnsTz.utcToZonedTime)(dateISOString, timeZone), timeZone);
  }

  return getFormattedDateStringMonthDayYearWithTime((0, _dateFnsTz.utcToZonedTime)(dateISOString, timeZone), timeZone);
};

exports.toDateTimeZone = toDateTimeZone;

var toNumericUs = function toNumericUs(date) {
  //eslint-disable-next-line no-console
  console.warn('DEPRECATED. Please switch to use the new function "getFormattedDateStringMonthDayYear".');
  return getFormattedDateStringMonthDayYear(date);
};

exports.toNumericUs = toNumericUs;

var formatDistanceString = function formatDistanceString(from, now, timeZone) {
  //eslint-disable-next-line no-console
  console.warn('DEPRECATED. Please switch to use the new function "getFormattedDateStringRelative".');
  return getFormattedDateStringRelative(from, now);
};

exports.formatDistanceString = formatDistanceString;